import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Card, CardBody, CardTitle, CardText, Row, Col} from 'reactstrap';
import styled from 'styled-components';

//images
import MandiriLogo from "../../images/logo-mandiri.png";
import MasterCard from "../../images/master-card.png";
import VisaLogo from "../../images/visa.png";
import OJKLogo from "../../images/ojk.png";

const MandiriCampaign = () => {
  return(
    <div id="helps-container">
      <h1 className="text-center">MANDIRI CAMPAIGN</h1>
      <Card>
        <CardBody>
          <CardTitle>Mandiri Campaign How-to</CardTitle>
          <CardText>
            Mandiri is sponsoring the collaboration in Kick Avenue where we release several highly sought-after sneakers every week in August and they will be raffled. This event is exclusive for Mandiri Debit and Credit Card holder.
          </CardText>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <CardTitle>General</CardTitle>
          <CardText style={{paddingLeft: '1rem'}}>
            <ol>
              <li>Every purchase above IDR 500.000,- will be accounted for a raffle ticket. And multiple draw is applicable with no maximum. (A purchase of IDR 5.000.000,- is worth 10 tickets). Tickets will be distributed along with your purchase.</li>
              <li>
                Only VISA and MasterCard Mandiri Debit/Credit Card is allowed.
              </li>
              <li>
                Every purchase and ticket allotment is registered in our system, therefore by having more tickets without a proper match in our data will not be considered eligible.
              </li>
              <li>Tickets are eligible for ALL raffles, except for winners. A user can only win once.</li>
              <li>Kick Avenue reserves the right and/or can replace the sizing of the product according to the availability should the winner's size is not available or due to particular circumstances.</li>
              <li>This event starts presently until November.</li>
            </ol>
          </CardText>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <CardTitle>Raffle Announcement and Collection</CardTitle>
          <CardText>
            <ol style={{paddingLeft: '1rem'}}>
              <li>Announcement will be done via Kick Avenue instagram</li>
                <ul style={{paddingLeft: '1rem'}}>
                  <li>1st raffle: August 13rd 2019 20.00</li>
                  <li>2nd raffle: August 20th 2019 20.00</li>
                  <li>3rd raffle: August 27th 2019 20.00 </li>
                </ul>
              <li>
                The products that are being raffled are multiple units of Adapt BB at IDR 5.199.000,-; Jordan 1 SB Lakers IDR 2.599.000,- ; Jordan 1 High Travis Scott IDR 3.099.000,-
              </li>
              <li>
                Every purchase and ticket allotment is registered in our system, therefore by having more tickets without a proper match in our data will not be considered eligible.
              </li>
              <li>Raffle winners must DM Kick Avenue Instagram within 24 hours to process the payment and claim the unit.</li>
              <li>The result of this raffle is final and fully authorized by Kick Avenue and supervised by Bank Mandiri.</li>
            </ol>
          </CardText>
        </CardBody>
      </Card>

      <WrapperLogo>
        <div className="wrapper-child">
          <KickImage src={MandiriLogo}/>
          <KickImage src={VisaLogo}/>
          <KickImage src={MasterCard}/>
        </div>
        <KickImage src={OJKLogo} className="ojk-logo"/>
      </WrapperLogo>

    </div>
  )
}

const WrapperLogo = styled.div`
  display: flex;
  flex-direction: column;
  .ojk-logo{
    object-fit: contain;
    width: 100%;
    height: 62px;
    align-self: center;
  }
  .wrapper-child{
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin-bottom: 2rem;
    img{
      object-fit: contain;
      &:first-child{
        width: 196px;
        height: 54px;
      }
      &:nth-child(2){
        width: 127px;
        height: 54px;
      }
      &:nth-child(3){
        width: 90px;
        height: 54px;
      }
    }
  }
  @media (min-width: 320px) and (max-width: 480px){
    .wrapper-child{
      margin-bottom: 1rem;
      img{
        object-fit: contain;
        &:first-child{
          width: 90px;
        }
        &:nth-child(2){
          width: 60px;
        }
        &:nth-child(3){
          width: 50px;
        }
      }
    }
  }
`

export default MandiriCampaign;